<div class="modal-header border-bottom">
  <h5 class="modal-title">Saved Replies</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body" style="height: 60vh; overflow-y: auto;">
  <div class="mb-3 position-relative col-6">
    <input type="text" class="form-control rounded-3" placeholder="Search" [(ngModel)]="searchTerm">
    <i class="fa-solid fa-magnifying-glass position-absolute top-50 end-0 translate-middle-y me-3 text-muted"></i>
  </div>
  <div *ngIf="isLoading" class="text-center py-4">
    <i class="fa-duotone fa-spinner-third fa-spin fs-3"></i>
  </div>
  <div *ngIf="!isLoading" class="table-responsive">
    <table class="table table-hover mb-0">
      <thead>
        <tr>
          <th>Title</th>
          <th>Message</th>
          <th>Shared With</th>
          <th class="text-end">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let template of paginatedTemplates">
          <td>{{ template.title }}</td>
          <td class="text-muted">{{ template.response_message }}</td>
          <td>{{ template.shared_with === 'everyone' ? 'Everyone' : 'Me' }}</td>
          <td class="text-end">
            <span class="badge badge-soft-primary cursor-pointer me-1" (click)="onUseTemplate(template, $event)">Use</span>
            <div *ngIf="isTemplateAuthor(template)" class="dropdown d-inline-block">
              <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown" (click)="$event.stopPropagation()">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-end">
                <li><a class="dropdown-item" (click)="onEditTemplate(template, $event)">Edit</a></li>
                <li><a class="dropdown-item text-danger" (click)="onDeleteTemplate(template, $event)">Delete</a></li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="!isLoading && filteredTemplates.length === 0" class="text-center py-4 text-muted">
      No templates found
    </div>
  </div>
</div>
<div *ngIf="totalPages > 1" class="modal-footer border-top d-flex justify-content-center">
  <nav>
    <ul class="pagination pagination-sm mb-0">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" (click)="goToPage(1)">&laquo;</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" (click)="goToPage(currentPage - 1)">&lsaquo;</a>
      </li>
      <li class="page-item active">
        <span class="page-link">{{ currentPage }}</span>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" (click)="goToPage(currentPage + 1)">&rsaquo;</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" (click)="goToPage(totalPages)">&raquo;</a>
      </li>
    </ul>
  </nav>
</div>
